import axiosPost from "../axiosPost";

export const migraUsuarioPasoGet = async (
    {
        migraUsuarioPasoId = null,
        migraPasoId = null,
        migraVueloId = null,
        migraTipoDePasoId = null,
        migraUsuarioPasoTipo = null,
        usuarioNroDeDocumentoX = null,
        usuarioApellidos = null,
        incluirVencidos = null,
        migraUsuarioPasoEstado = null,
        fechaDesde = null,
        fechaHasta = null,
        page = null,
        pageSize = null,
    } = {},
    credentials
) => {
    const body = {
        service: "MigraUsuarioPasoGet",
        params: {
            merchantId: credentials.merchantId,
            migraUsuarioPasoId,
            migraPasoId,
            migraVueloId,
            migraTipoDePasoId,
            migraUsuarioPasoTipo,
            usuarioNroDeDocumentoX,
            usuarioApellidos,
            incluirVencidos,
            migraUsuarioPasoEstado,
            fechaDesde,
            fechaHasta,
            page,
            pageSize,
        },
    };

    const response = await axiosPost(body, credentials);

    if (page !== null && pageSize !== null) {
        return {
            result: response.result,
            total: response.status?.id,
            status: response.status,
        };
    }

    return response;
};
